export var ValueMappingType;
(function (ValueMappingType) {
    ValueMappingType["VALUE_MAPPING_TYPE_EXACT"] = "VALUE_MAPPING_TYPE_EXACT";
    ValueMappingType["VALUE_MAPPING_TYPE_RANGE"] = "VALUE_MAPPING_TYPE_RANGE";
})(ValueMappingType || (ValueMappingType = {}));
